<template>
<div class="animated fadeIn mt-5">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <div class="col-md-6">
        <b-card>
          <div slot="header">
            <strong>Item</strong>
          </div>
          <b-form-fieldset label="Nome">
            <b-form-input type="text" name="name" v-model="item.name" placeholder="Nome"  v-validate="'required'" :state="validateState('name')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('name') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-fieldset label="Email">
            <b-form-input type="email" name="email" v-model="item.email" placeholder="Email" v-validate="{ required: true, email:true, uniqueemail: item.id }" :state="validateState('email')" data-vv-validate-on="change" ></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('email') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-fieldset label="Código UFS">
            <b-form-input id="ufs_code" type="text" name="ufs_code" v-model="item.ufs_code" placeholder="Código UFS"  v-validate="{  }" :state="validateState('ufs_code')" data-vv-validate-on="change"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('ufs_code') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-fieldset label="Nome de utilizador">
            <b-form-input id="itemName" type="text" name="username" v-model="item.username" placeholder="Nome de utilizador"  v-validate="{ username: item.id, required: true, min:5 }" :state="validateState('username')" data-vv-validate-on="change"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('username') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-fieldset label="Palavra-passe">
            <b-input-group>
              <b-form-input :type="!showPassword?'password':'text'" name="password" v-model="item.password" placeholder="Palavra-passe" :state="validateState('password')" v-validate="{min: 8, required:passwordRequired}" ref="password" ></b-form-input>
              <b-input-group-append>
                <b-button  v-on:click="toggleViewPassword()"><i v-bind:class="{'fa-eye':!showPassword, 'fa-eye-slash':showPassword}" class="fa"></i></b-button>
                <b-button variant="info" v-on:click="generate()">Gerar palavra-passe {{passwordRequired}}</b-button>
              </b-input-group-append>
              <b-form-invalid-feedback>
                {{ errors.first('password') }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-fieldset>
          <b-form-fieldset label="Confirme a palavra-passe">
            <b-form-input :type="!showPassword?'password':'text'" name="password_confirmation" v-model="item.password_confirmation" :state="validateState('password_confirmation')" placeholder="Confirme a palavra-passe" v-validate="{confirmed: 'password', required:confirmPasswordRequired}"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('password_confirmation') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>


          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'users.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <!--/.col-->
      <div class="col-md-3">
        <b-card>
          <div slot="header">
            <strong>Estado</strong>
          </div>
          <b-form-fieldset label="Estado">
            <b-form-select v-model="item.state" class="mb-3">
              <option value="0">Bloqueado</option>
              <option value="1">Activo</option>
            </b-form-select>
          </b-form-fieldset>
          <b-form-fieldset v-if="!item.id" label="Enviar email de boas vindas">
            <b-form-select v-model="item.sendEmail" class="mb-3">
              <option :value="null">Escolha uma opção</option>
              <option value="0">Não</option>
              <option value="1">Sim</option>
            </b-form-select>
          </b-form-fieldset>
        </b-card>
        <b-card>
          <div slot="header">
            <strong>Grupos</strong>
          </div>
          <b-form-checkbox-group id="roles" name="roles" v-model="item.roles_list">
            <div v-for="role in roles" :key="role.id">
              <b-form-checkbox :value="role.id">{{role.name}}</b-form-checkbox>
            </div>
          </b-form-checkbox-group>
        </b-card>
      </div>

      <!--/.col-->
    </div>
  </form>
  <b-modal @shown="showTeam=true" @hidden="showTeam=false" size="lg" ref="teamMembersModal" id="teamMembersModal">
    <team-members v-if="showTeam" height="400" v-on:select-member="selectTeamMembers" />
  </b-modal>
</div>
</template>

<script>
import TeamMembers from './TeamMembers.vue'
export default {
  name: 'UsersEdit',
  props: ['id'],
  components: { TeamMembers },
  data() {
    return {
      showTeam: false,
      showPassword: false,
      item: {
        name: '',
        password: '',
        password_confirmation: '',
        state: 1,
        sendEmail: null,
        roles: [],
        salesteam: {data: []}
      },
      roles: [],
      passwordSize: 12,
      characters: 'a-z,A-Z,0-9,#'
    }
  },
  computed: {
    passwordRequired: function() {
      return !this.item.id
    },
    confirmPasswordRequired: function() {
      return this.item.password.length > 0
    }
  },
  methods: {
    selectTeamMembers(e) {
      this.item.salesteam.data.push({ id: e.item.id, name: e.item.name })
    },
    showTeamModal() {
      this.$refs.teamMembersModal.show()
    },
    hideTeamModal() {
      this.$refs.teamMembersModal.hide()
    },
    removeTeamMember(index) {
      this.item.salesteam.data.splice(index, 1)
    },
    toggleViewPassword() {
      this.showPassword = !this.showPassword
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$toastr('error', 'Tem campos inválidos', 'Erro')
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('admin/users' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$toastr('success', 'item gravado com sucesso', 'Gravado')
            if (close) {
              this.$router.push({
                name: 'users.index'
              })
            }
          })
          .catch(response => {
            this.$toastr('error', 'Não foi possivel gravar', 'Erro')
          })
      } else {
        this.axios.post('admin/users', data)
          .then(response => {
            this.item = response.data.data
            this.$toastr('success', 'item gravado com sucesso', 'Gravado')
            this.$router.push({
              name: 'users.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$toastr('error', 'Não foi possivel gravar', 'Erro')
          })
      }
    },
    generate() {
      let charactersArray = this.characters.split(',')
      let CharacterSet = ''
      let password = ''

      if (charactersArray.indexOf('a-z') >= 0) {
        CharacterSet += 'abcdefghijklmnopqrstuvwxyz'
      }
      if (charactersArray.indexOf('A-Z') >= 0) {
        CharacterSet += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      }
      if (charactersArray.indexOf('0-9') >= 0) {
        CharacterSet += '0123456789'
      }
      if (charactersArray.indexOf('#') >= 0) {
        CharacterSet += '![]{}()%&*$#^<>~@|'
      }

      for (let i = 0; i < this.passwordSize; i++) {
        password += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length))
      }
      this.item.password = password
      this.item.password_confirmation = password
      this.showPassword = true
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('admin/users' + '/' + id)
        .then(response => {
          this.item = response.data.data
        })
        .catch(response => {
          this.$toastr('error', 'Este utilizador não existe', 'Erro')
          this.$router.push({
            name: 'users.index'
          })
        })
    } else {
      this.item.sendEmail = 1
    }
    this.axios.get('admin/roles/lst').then(response => {
      this.roles = response.data.data
    })
  }
}
</script>



// WEBPACK FOOTER //
// UsersEdit.vue?6b187fb0